import React, { useEffect, useState } from 'react'
import PublicAppHeader from '../PublicAppHeader'
import { APP_CONSTANTS } from 'src/consumer/constants'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import {
  SPLPCardsProviderComponent,
  SPLPTopLevelFilterComponent,
} from './ServiceProvidersListingComponents'
import { getDataWithoutParams } from 'src/consumer/services/featureServices'
import { PublicAppFooter } from '../PublicAppFooter'
import { useNavigate } from 'react-router-dom'

export const selectedTabApiData = {
  therapist: '/api/external/mentor/1on1/list?categories=therapist',
  psychiatrist: '/api/external/mentor/1on1/list?categories=psychiatrist',
  clinical_psychologist: '/api/external/mentor/1on1/list?categories=clinical_psychologist',
}

export default function TherapistPsychiatristListingPage() {
  const navigate = useNavigate()
  const [selectedTabId, setSelectedTabId] = useState('therapist')
  const [plansData, setPlansData] = useState([])

  async function pageSetup() {
    const response = await getDataWithoutParams('/api/subscription-plan/1on1')
    if (response?.status === 200 && response?.data?.length > 0) {
      setPlansData(response?.data)
    }
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams?.has('t')) {
      if (['therapist', 'psychiatrist', 'clinical_psychologist'].includes(urlParams.get('t'))) {
        setSelectedTabId(urlParams.get('t'))
      }
    }
  }, [])

  useEffect(() => {
    pageSetup()
  }, [])

  return (
    <>
      <SEOComponent
        title="Therapy & Psychiatry for Mental Wellness | AUMHUM"
        description="Enhance your mental health with personalized treatment plans crafted by expert Psychologists & Psychiatrists."
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={["psychiatry", "consult", "heal", "grow"]}
      />
      <PublicAppHeader config={{ showLinks: true }} /> {/* header component */}
      <SPLPTopLevelFilterComponent
        selectedTabId={selectedTabId}
        setSelectedTabId={setSelectedTabId}
        onSelectedTabChange={(newtab) => navigate(`${window.location.pathname}?t=${newtab}`)}
        options={[
          {
            id: 'therapist',
            label: 'Therapist',
            helpText:
              'Reset, heal, and grow with our expert therapist, here to support you at every step. Book your session and start making a positive change today!',
          },
          {
            id: 'psychiatrist',
            label: 'Psychiatrist Rx',
            helpText:
              'Find balance with our expert psychiatrist, guiding your mental health journey and prescribing medication if needed.',
          },
          {
            id: 'clinical_psychologist',
            label: 'Clinical Psychologist',
            helpText:
              'Reset, heal, and grow with our expert therapist, here to support you at every step. Book your session and start making a positive change today!',
          },
        ]}
        primaryHeading="Who do you want to consult?"
        actionText="Have Questions?"
        actionTextAnchor="faq-modal-open"
        actionTextFaqDomain="therapy"
      />
      {/* second level filtering component that will also change the api to be fired by cards provider */}
      <SPLPCardsProviderComponent
        apiCall={selectedTabApiData?.[selectedTabId]}
        plansData={plansData}
        showPriceFromPlansData={true}
        twoColumnDesign={false}
      />
      {/* need help or an ad */}
      {/* <SPLPCardsProviderComponent /> */}
      <PublicAppFooter />
    </>
  )
}
